import setReduxAction from '../../../redux/actions/set'
import { START_WORKOUT_ACTION, START_WORKOUT_PATH } from '../../constants'

function updateHasStartedStartWorkoutAction (value) {
  return setReduxAction({
    type: value
      ? START_WORKOUT_ACTION.START
      : START_WORKOUT_ACTION.PAUSE,
    payload: {
      path: START_WORKOUT_PATH.HAS_STARTED,
      value
    }
  })
}

export default updateHasStartedStartWorkoutAction
